<template>
  <div class="personal">
    <Nav></Nav>
    <div style="height: 80px"></div>
    <div class="personal-bottom">
      <div class="personal-bottom-bottom">
        <div class="personal-bottom-bottom-left">
              <slide @change="changeSlide"></slide>
        </div>
        <div class="personal-bottom-bottom-right">
          <div class="personal-bottom-bottom-right-top">
            <div>我的位置：</div>
            <el-breadcrumb
              class="daohang"
              separator-class="el-icon-arrow-right"
            >
              <el-breadcrumb-item
                class="xinxi"
                :to="{ path: '/shezhiguanliyuan' }"
                ><span>主播管理</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item class="xinxi" :to="{ path: '/guanlijinyan' }"
                ><span>管理禁言</span>
              </el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="personal-bottom-bottom-right-bottom">
            <div class="title_box">
              <span class="lines"></span>
              <span>添加禁言</span>
            </div>
            <div class="set_admin">
              <div class="inputs">
                <span class="name">UID</span>
                <el-input
                  type="text"
                  placeholder="请输入UID"
                  v-model.trim="uid"
                  maxlength="10"
                  show-word-limit
                ></el-input>
              </div>
              <!-- <div style="margin-left:30px;display:flex;">
                                <div style="color:#ffffff;line-height: 40px;">禁言期限</div>
                                <div class="jinyan" style="margin-left:10px;">
                                    <el-select v-model="value" clearable placeholder="请选择">
                                      <el-option style="color:#ffffff;"
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-select>
                                </div>
                            </div> -->
              <div
                @click="jinyan"
                 class="add_uid"
              >
                添加
              </div>
            </div>
            <div class="title_box">
              <span class="lines"></span>
              <span>禁言管理</span>
            </div>
            <div class="set_admin">
              <div class="inputs">
                <span class="name">UID</span>
                <!-- <input
                  v-model="uid2"
                  placeholder="请输入用户UID"
                  type="text"
                /> -->
                <el-input
                  type="text"
                  placeholder="请输入用户UID"
                  v-model.trim="uid2"
                  @keyup="this.value=this.value.replace(/[, ]/g,'')"
                  maxlength="10"
                  show-word-limit
                ></el-input>
              </div>
              <div
                @click="Query"
                class="add_uid"
              >
                查询
              </div>
              </div>
              <!-- <div style="margin-left:30px;">
                                <span style="color:#ffffff;">用户名称</span>
                                <input style="font-size:16px;color:#ffffff;padding-left:10px;width: 190px;height: 40px;background: #464646;border-radius: 4px 6px 6px 4px;margin-left:10px;border:0;outline: none;" placeholder="请输入用户名称" type="text">
                            </div> -->
              <!-- <div style="margin-left:30px;display:flex;">
                                <div style="color:#ffffff;line-height:40px;">禁言期限</div>
                                <div class="jinyan" style="margin-left:10px;">
                                    <el-select v-model="value1" clearable placeholder="请选择">
                                      <el-option style="color:#ffffff;"
                                        v-for="item in options"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-select>
                                </div>
                            </div> -->
            <div
              class="table_list"
            >
              <div
                class="tb_header"
              >
                <div style="width: 5%">编号</div>
                <div style="width: 15%">用户昵称</div>
                <div style="width: 15%">用户UID</div>
                <div style="width: 17%">操作人UID</div>
                <div style="width: 17%">禁言时间</div>
                <div style="width: 17%">解禁时间</div>
                <div style="width: 14%">操作</div>
              </div>

              <div  class="tb_content">
                <div
                  class="tb_content_item"
                >
                  <div
                    v-for="(item, index) in jinyanData"
                    :key="index"
                    v-if="item.operatorUid !== 1 && item.muteExpireTime !=''"
                    class="tb_item"
                  >
                    <div style="width: 5%">{{ index + 1 }}</div>
                    <div style="width: 15%">
                      {{ item.muteNickname | banned }}
                    </div>
                    <div style="width: 14%">{{ item.muteUid }}</div>
                    <div style="width: 17%">{{ item.operatorUid }}</div>
                    <div style="width: 16.9%">
                      {{ dateFormat(item.muteCreateTime) }}
                    </div>
                    <div v-if="item.muteExpireTime == -1" style="width: 16.3%">
                      永久
                    </div>
                    <div v-else style="width: 16.3%">
                      {{ item.muteExpireTime }}
                    </div>
                    <!-- <div v-if="item.operatorUid == 1" style="width:14%;display: flex;align-items: center;color:#393939;" title="官方禁言不可解禁">
                                            <img style="cursor:no-drop;" src="https://oss.ansongqiubo.com/assets/personimage/quxiaogl.png" alt="">
                                            <div style="cursor:no-drop;margin-left:6px;font-size:14px;">解除禁言</div>
                                        </div> -->
                    <div style="width: 14%; display: flex; align-items: center">
                      <img
                        @click="jiechujinyan(item.muteUid)"
                        style="cursor: pointer"
                        src="https://oss.ansongqiubo.com/assets/personimage/quxiaogl.png"
                        alt=""
                      />
                      <div
                        @click="jiechujinyan(item.muteUid)"
                        style="
                          color: #ED1010;
                          cursor: pointer;
                          margin-left: 6px;
                          font-size: 14px;
                        "
                      >
                        解除禁言
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div v-if="jinyanData.length==0">
                  <el-empty description="没有数据哦"></el-empty>
                </div> -->
              </div>
            </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "../component/Nav.vue";
import qs from "qs";
import slide from './template_slide.vue'
export default {
  name: "App",
  data() {
    return {
      b: 1,
      options: [
        {
          value: "选项1",
          label: "5分钟",
        },
        {
          value: "选项2",
          label: "30分钟",
        },
        {
          value: "选项3",
          label: "3小时",
        },
        {
          value: "选项4",
          label: "1天",
        },
        {
          value: "选项5",
          label: "3天",
        },
        {
          value: "选项6",
          label: "7天",
        },
        {
          value: "选项7",
          label: "永久",
        },
      ],
      value: "",
      value1: "",
      jinyanData: [], //禁言列表数据
      roomids: 0, //主播id
      uid: null, //禁言的用户id
      uid2: null, //查询列表
      activeName: 1,
    };
  },
  created() {
    this.cooke = localStorage.getItem("token");
    if(this.cooke ){
      this.$store.dispatch('getUserInfoData').then((result) => {
        this.roomid(result.userInfo.uid);
      })
    }
  },
  filters: {
    banned(value) {
      if (!value) return "";
      if (value.length > 6) {
        return value.slice(0, 6) + "...";
      }
      return value;
    },
  },
  methods: {
      changeSlide(data){
              this.$router.push(data);
            },
    dateFormat: function (time) {
      var times = time * 1000;
      var date = new Date(times);
      var year = date.getFullYear();
      var month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var hours =
        date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      // 拼接
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
    roomid(e) {
      this.roomids = e;
      //   console.log(e);
      this.jinyanliebiao(e);
    },
    //   禁言列表
    jinyanliebiao(e) {
      this.$axios
        .get(this.api + "/v1/manage/user/mutelist", {
          params: {
            uid: 0,
          },
          headers: {
            device: "web",
            packageId: "1",
            channel: "web",
            version: "1.0.0",
            "authToken": localStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log('获取禁言列表',this.uid,this.uid2);
          this.jinyanData = res.data.data;
        });
    },
    // 解除禁言
    jiechujinyan(e) {
      console.log(e);
      console.log(this.roomids);
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/manage/user/unmute",
        method: "post",
        data: {
          roomId: this.roomids,
          uid: e,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.message == "success") {
          this.jinyanliebiao();
          this.uid2 = "";
        } else {
          alert(res.data.message);
        }
      });
    },
    //   添加禁言
    jinyan() {
      console.log(this.roomids);
      this.$axios({
        headers: {
          device: "web",
          packageId: "1",
          version: "1.0.0",
          channel: "web",
          "authToken": localStorage.getItem("token"),
          "Content-Type": "application/x-www-form-urlencoded",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = qs.stringify(data);
            //   console.log(data);
            return data;
          },
        ],
        url: this.api + "/v1/manage/user/mute",
        method: "post",
        data: {
          roomId: this.roomids,
          uid: this.uid,
        },
      }).then((res) => {
        //   console.log(res);
        if (res.data.message == "success") {
          this.jinyanliebiao();
          this.uid = "";
        } else {
          alert(res.data.message);
        }
      });
    },
    // 查询禁言
    Query() {
      console.log(this.uid2);
      this.$axios
        .get(this.api + "/v1/manage/user/mutelist", {
          params: {
            uid: this.uid2,
          },
          headers: {
            device: "web",
            packageId: "1",
            channel: "web",
            version: "1.0.0",
            "authToken": localStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res);
          this.jinyanData = res.data.data;
        });
    },
    dianji(e) {
      this.b = e;
    },
    Mingcheng(e, i) {
      // console.log(e,i);
      if (e == 0 && i == 0) {
        this.$router.push("/personalc");
      }
      if (e == 0 && i == 1) {
        this.$router.push("/wodeguanzhu");
      }
      if (e == 0 && i == 2) {
        this.$router.push("/wodefensi");
      }
      if (e == 0 && i == 3) {
        this.$router.push("/lishiguankan");
      }
      if (e == 0 && i == 4) {
        this.$router.push("/wodezichan");
      }
      if (e == 0 && i == 5) {
        this.$router.push("/wodexinxi");
      }
      if (e == 1 && i == 0) {
        this.$router.push("/shezhiguanliyuan");
      }
      // if (e==1&&i==1) {
      //     this.$router.push('/guanlijinyan')
      // }
      if (e == 1 && i == 2) {
        this.$router.push("/tianjiazhiboyuan");
      }
      if (e == 2 && i == 0) {
        this.$router.push("/wodeshouyi");
      }
      if (e == 2 && i == 1) {
        this.$router.push("/yonghupaihangbang");
      }
      // if (e == 3&&i == 0) {
      //     this.$router.push('/shipinfabu')
      // }
      // if (e == 3&&i == 1) {
      //     this.$router.push('/ziyuanguanli')
      // }
      if (e == 3 && i == 0) {
        this.$router.push("/zhiboshuju");
      }
      // if (e==4&&i==1) {
      //     this.$router.push('/shipinshuju')
      // }
    },
  },
  components: {
    Nav,
    slide
  },
};
</script>

<style scoped lang='scss'>
.personal-bottom-bottom-left .el-collapse {
  width: 100%;
  background: #f7f8fa;
}
.personal-bottom-bottom-left .el-collapse-item__wrap {
  background: #f7f8fa;
  color: #333;
}
.personal {
  width: 100vw;
  background: #f7f8fa;
  .xzcxzcxz {
    color: rgba(114, 30, 220, 1) !important;
  }
  .personal-bottom {
    background-color: #f7f8fa;
  }
  .personal-bottom-top {
    width: 100%;
    height: 60px;
    min-width: 1240px;
    background-color: #fff;
  }
  .personal-bottom-top-div {
    width: 1240px;
    height: 60px;
    margin: 0 auto;
    color: #333;
    font-size: 23px;
    line-height: 60px;
    display: flex;
    align-items: center;
  }
  .personal-bottom-top-div-div {
    width: 6px;
    height: 50px;
    background-color: #721edc;
    border-radius: 6px;
  }
}
.personal-bottom-bottom {
  width: 1200px;
  height: calc(100vh - 105px);
  margin: 0 auto;
  display: flex;
  background-color: #f7f8fa;
  min-width: 1200px;
  .personal-bottom-bottom-left {
    width: 190px;
    height: 100%;
    background-color: #fff;
    margin-top: 16px;
    color: #333;
    .myel-collapse-item {
      width: 190px;
    }
    .prent_item {
      text-align: center;
      width: 100%;
      height: 100%;
      display: flex;
      .parent_icon {
        display: flex;
        align-items: center;
      }
      .parent_name {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
    .child_item {
      color: #a6a6a6;
      width: 100%;
      height: 52px;
      line-height: 52px;
      background-color: #f2f2f2;
      .child_img {
        display: flex;
        align-items: center;
      }
      .child_name {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

.personal-bottom-bottom-right {
  margin-left: 12px;
  height: 100%;
  flex: 2;
  max-width: 998px;
  background-color: #fff;
  padding: 30px 20px;
  box-sizing: border-box;
  margin-top: 16px;
  .personal-bottom-bottom-right-top {
    background-color: #fff;
    display: flex;
    align-items: center;
    .xinxi {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
    }
    .xinxi:hover {
      color: #721edc;
    }
  }
}

.maxtitle {
  font-size: 20px !important;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600 !important;
  color: #333333;

  span {
    font-weight: 600 !important;
    color: #333333;
  }
}
.personal-bottom-bottom-right-bottom {
  height: calc(94% - 15px);
  box-sizing: border-box;
  margin-top: 25px;
  padding-top: 15px;
  border-top: 1px solid rgba(0, 0, 0, 0.2);

   .table_list {
    box-sizing: border-box;
    color: #ffffff;
    margin-top: 25px;
  }

.tb_content {
  .tb_content_item {
    height: 330px;
    overflow-y: auto;
  }
}
.tb_item {
  line-height: 47px;
  padding-left: 10px;
  display: flex;
  color: rgba(102, 102, 102, 1);
  height: 47px;
  padding: 0 12px;
  background-color: rgba(247, 248, 250, 1);
  border-bottom: 1px solid rgba(102, 102, 102, .1);
}
  .tb_header {
    padding:0 12px;
    height: 34px;
    background: #faf6ff;
    line-height: 34px;
    display: flex;
    height: 34px;
    font-weight: 400;
    color: #333333;
    font-size: 16px;
  }
  .title_box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .lines {
      display: inline-block;
      width: 4px;
      margin-right: 6px;
      border-radius: 4px;
      height: 20px;
      background: #721edc;
    }
    span {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #333333;
    }
  }
}
.add_uid {
  cursor: pointer;
  margin-left: 30px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;

  width: 64px;
  height: 36px;
  line-height: 36px;
  background: #721edc;
  border-radius: 4px 6px 6px 4px;
  background: #721edc;
  border-radius: 4px;
}
.set_admin {
  display: flex;
  align-items: center;
  margin: 15px 0;
  .inputs {
    display: flex;
    align-items: center;
    span.name {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      margin-right: 12px;
    }
  }
}
.daohang {
  display: flex;
  color: white;
  width: 500px;
  //   margin-left: 20px;
}
.xinxi {
  display: flex;
  align-items: center;
  font-size: 24px;
}
.personal-bottom-bottom-right-bottom-top {
  /* width: 100%; */
  display: flex;
  height: 130px;
  border-bottom: 1px #464646 solid;
}
.personal-bottom-bottom-right-bottom-center1 {
  margin-top: 15px;
  height: 100px;
  border-bottom: 1px #464646 solid;
}
.personal-bottom-bottom-right-bottom-center2 {
  margin-top: 15px;
  /* height: 100px; */
  width: 100%;
}
.biao {
  width: 16px;
  height: 16px;
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou.png);
}
</style>
<style scoped="scoped">
.colorBiao {
  background-image: url(https://oss.ansongqiubo.com/assets/personimage/jiantou1.png) !important;
}
.xzcxzcxz {
  color: white;
}
.jinyan .el-input__inner {
  background: #F7F8FA;

}
.jinyan .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: red;
}
.jinyan .el-input__inner {
  color: white;
}
/* .el-select-dropdown {
 background-color: #F7F8FA !important;
  border: 1px solid #F7F8FA !important;
}
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #F7F8FA !important;
}
.el-popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #F7F8FA !important;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #464646 !important;
} */
/* .inputs .el-input__inner {
  background-color: #464646 !important;
  border: 1px solid #464646;
  color: rgb(255, 255, 255);
} */
/* .inputs .el-input .el-input__count .el-input__count-inner {
  background-color: #464646;
} */
</style>



// WEBPACK FOOTER //
// src/component/Guanlijinyan.vue